module.exports = __webpack_public_path__ + "static/media/site-intro.c37858e7.gif";